import { collection, doc, addDoc, getDoc, getDocs, query, where, orderBy, updateDoc, serverTimestamp } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../config/firebase';

// ═══════════════ TRIGGER SOS ═══════════════
export async function triggerSOS(bookingId, userId, role, location, silent = false) {
  const fn = httpsCallable(functions, 'triggerSOS');
  return (await fn({ bookingId, userId, role, lat: location.lat, lng: location.lng, silent })).data;
}

// ═══════════════ EMERGENCY CONTACTS ═══════════════
export async function getEmergencyContacts(userId) {
  const q = query(collection(db, 'users', userId, 'emergencyContacts'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

export async function addEmergencyContact(userId, contact) {
  return addDoc(collection(db, 'users', userId, 'emergencyContacts'), {
    ...contact, notifyOnSOS: true, addedAt: serverTimestamp(),
  });
}

export async function removeEmergencyContact(userId, contactId) {
  const { deleteDoc } = await import('firebase/firestore');
  await deleteDoc(doc(db, 'users', userId, 'emergencyContacts', contactId));
}

// ═══════════════ REPORT INCIDENT ═══════════════
export async function reportIncident(data) {
  const fn = httpsCallable(functions, 'reportIncident');
  return (await fn(data)).data;
}

// ═══════════════ GET INCIDENTS ═══════════════
export async function getIncidents(userId = null) {
  let q;
  if (userId) {
    q = query(collection(db, 'incidents'), where('reportedBy', '==', userId), orderBy('createdAt', 'desc'));
  } else {
    q = query(collection(db, 'incidents'), orderBy('createdAt', 'desc'));
  }
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

// ═══════════════ DRIVER CHECK-IN RESPONSE ═══════════════
export async function respondToCheckIn(bookingId) {
  const fn = httpsCallable(functions, 'driverCheckIn');
  return (await fn({ bookingId })).data;
}
